<template>
    <section>
        <div class="container is-fluid">
            <div class="columns is-multiline">
                <div class="column is-one-third" v-for="dealInfo in $store.state.property.dealInfoList" :key="dealInfo.id">
                    <div class="card">
                        <div class="card-content">
                            <div class="has-text-weight-semibold">{{ dealInfo.description }}</div>
                            <div class="is-size-6">{{ dealInfo.value }}</div>
                            <div class="level-left">
                                <div class="level-item">
                                    <span class="link">
                                        <b-tooltip label="Edit" position="is-bottom">
                                            <i class="fas fa-edit" @click="editNote(note)"></i>
                                        </b-tooltip>
                                    </span>
                                </div>
                                <div class="level-item">
                                    <span class="icon">
                                        <b-tooltip label="Delete" position="is-bottom">
                                            <i class="fas fa-trash" @click="deleteNote(note)"></i>
                                        </b-tooltip>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {};
</script>

<style>
</style>
